(function () {
  'use strict';

  try {
    if (!window || !window.location) return;

    var params = null;
    try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
    var utm = '';
    if (params) utm = (params.get('utm_campaign') || '');
    if (!utm) return;

    var current = null;
    try { current = (window.Shopify && Shopify.cart && Shopify.cart.attributes && Shopify.cart.attributes.utm_campaign) || null; } catch (e) { current = null; }

    var cached = null;
    try {
      cached = (document.cookie.match(/(^|;)\s*utm_campaign_cached=([^;]*)/) || [])[2];
      if (cached) cached = decodeURIComponent(cached);
    } catch (e) { cached = null; }

    if (utm === current || utm === cached) return;

    try {
      var form = new FormData();
      form.append('attributes[utm_campaign]', utm);

      fetch('/cart/update.js', {
        method: 'POST',
        body: form,
        credentials: 'same-origin',
        keepalive: true,
        cache: 'no-cache'
      }).then(function (response) {
        if (!response || !response.ok) return;

        // Quick cookie fallback (7 days)
        try {
          var expireDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
          var cookieStr = 'utm_campaign_cached=' + encodeURIComponent(utm) + '; path=/; expires=' + expireDate.toUTCString() + '; SameSite=Lax';
          if (window.location.protocol === 'https:') cookieStr += '; Secure';
          document.cookie = cookieStr;
        } catch (e) {}

        try { window.location.reload(); } catch (e) { /* swallow */ }
      }).catch(function () {
        try {
          var _expire = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
          var _cookie = 'utm_campaign_cached=' + encodeURIComponent(utm) + '; path=/; expires=' + _expire.toUTCString() + '; SameSite=Lax';
          if (window.location.protocol === 'https:') _cookie += '; Secure';
          document.cookie = _cookie;
        } catch (e) {}
        try { window.location.reload(); } catch (e) { /* swallow */ }
      });
    } catch (e) {
      // If building the request fails for any reason, do nothing
    }
  } catch (e) {
    // Final safety: don't throw in page context
  }
})();